/**
 * React dependencies
 */

import React, { useState, useEffect } from 'react';

/**
 * useFetchBasicRequest hook
 *
 * Custom hook to handle data from an array of endpoints. Mostly for use with WP Rest API and ACF.
 *
 * @param {Array} endpoints
 * @param {string} method
 * @param {Object} body
 */
const useFetchBasicRequest = ( endpoints, method, body = null ) => {
  const [ loading, setLoading ] = useState( false );
  const [ error, setError ] = useState( false );
  const [ data, setData ] = useState( [] );

  const controller = new AbortController();
  const signal = controller.signal;

  const makeRequest = () => {
    setLoading( true );

    setupRequest()
      .then( ( responses ) => {
        return Promise.all( responses.map( ( response ) => {
          return response.json();
        }) );
      })
      .then( ( data ) => {
        // console.log(data);
        setData( data );
        setLoading( false );
      })
      .catch( ( error ) => {
        console.error( error );
        setError( true );
      });
  };

  const setupRequest = async() => {
    const baseUrl = window.location.origin;
    const ajaxNonce = typeof ajax_object !== 'undefined' ? ajax_object.nonce : null;
    const args = {
      method,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        // eslint-disable-next-line camelcase, no-undef
        'X-WP-Header': ajaxNonce
      },
      signal,
      body
    };

    const responses = await Promise.all( endpoints.map( ( path ) => fetch( `${baseUrl}/${path}` ), args ) );
    const ok = responses.map( ( response ) => response.ok );

    if ( ok.includes( false ) ) {
      setError( true );
    }

    const responseData = await responses;

    return responseData;
  };

  useEffect( () => {
    // makeRequest();
    return () => controller.abort();
  }, [] );

  return {
    makeRequest,
    loading,
    error,
    data
  };
};

export default useFetchBasicRequest;
